import { Component} from '@angular/core';

@Component({
    selector: 'process-main',
    templateUrl: './process-main.tmpl.html'
})

export class ProcessMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  